<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>USE CASES</div>
				<h2 waHeading="l" waText>Matching Patterns to Problems</h2>
				<p waBody="m" waColorText="quiet" waText>From CRUD forms to real-time dashboards &mdash; the right tool for each job.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>CRUD Applications</h3>
							<p waBody="m" waColorText="quiet" waText>REST endpoints for API access. AJAX events for form submissions and interactive buttons. Standard request/response &mdash; no real-time needed.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>REST + AJAX</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Live Data Grids &amp; Charts</h3>
							<p waBody="m" waColorText="quiet" waText>AG Grid and Chart.js register WebSocket receivers on the Vert.x event bus. Push new data from the server &mdash; components update in real time.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Vert.x event bus</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Push Notifications</h3>
							<p waBody="m" waColorText="quiet" waText>Send user-specific or broadcast notifications from event handlers, scheduled tasks, or message consumers.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Vert.x or RabbitMQ</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Collaborative &amp; IoT</h3>
							<p waBody="m" waColorText="quiet" waText>Multi-user editing, live presence, sensor telemetry. RabbitMQ provides durability and multi-instance fan-out.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>RabbitMQ</div>
						</div>
					</wa-card>
				</div>
				<div class="wa-cluster wa-gap-s">
					<wa-button [routerLink]="['/getting-started']" variant="brand">Get Started</wa-button>
					<wa-button [routerLink]="['/plugins']" appearance="outlined" variant="neutral">Full Plugin Catalog</wa-button>
				</div>
			</div>
		</div>
	</div>
</div>